import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AlertService } from '../services/alert.service';
import { AuthenticationService } from '../services/authentication.service';
import { AEntity } from '../models/a-entity';

export abstract class BaseComponent {
    gridMessages: { emptyMessage: string, totalMessage: string };

    headerHeight: number;

    private _hiddeFilter: boolean;
    get hiddeFilter(): boolean { return this._hiddeFilter; }
    set hiddeFilter(value: boolean) {
        this._hiddeFilter = value;
        this.headerHeight = value ? 55 : 65;
    }

    protected readonly _authService: AuthenticationService;
    protected readonly _alert: AlertService;
    protected readonly _translate: TranslateService;

    isRequesting: boolean;

    /**
     * Create a global class to manage global component actions
     * @param injector - injector root service used in app.module
     */
    constructor(protected _injector: Injector) {
        this._authService = _injector.get(AuthenticationService);
        this._alert = _injector.get(AlertService);
        this._translate = _injector.get(TranslateService);

        this.gridMessages = { emptyMessage: this._translate.instant('grid.emptyMessage'), totalMessage: this._translate.instant('grid.totalMessage') };
        this.hiddeFilter = true;
    }

    protected get currentUrl(): string {
        return this._authService.currentUrl;
    }
    protected get structurePath(): string {
        return this._authService.structurePath;
    }

    /**
     * Navigate to the next url
     * @param url - Url to navigate
     * @param queryParams - Additional param for the navigation
     */
    protected navigate(url: string, extra?: any, hideNavigation: boolean = false) {
        this._authService.navigate(url, extra, hideNavigation);
    }

    getReason(type: string, hasRight: boolean = true): string {
        if (!hasRight) return this._translate.instant('common.noPrivilege');
        return '';
    }

    getErrorTooltip(control) {
        if (!(control.invalid && (control.dirty || control.touched))) return null;
        if (!control.errors) return null;

        var error: string = '';
        for (let key in control.errors) {
            var e = control.errors[key];

            if (typeof (e) === "boolean") { if (!(e as boolean)) continue; }
            else if (e.valid !== undefined && e.valid) continue;

            if (error) error += '\n';
            error += this._translate.instant(key);
        }

        return error;
    }
    
    compareById(f1: AEntity, f2: AEntity) {
        return f1 && f2 && f1.id === f2.id;
    }
}
